import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/access';
import { CountryRegionsPage } from '@/features/country-region/list-page';

export const Route = createFileRoute(
  '/_authenticated/operations/country-regions',
)({
  beforeLoad: ({ context, location }) =>
    requirePermission(
      context.queryClient,
      location.href,
      'countryRegions:read',
    ),
  component: CountryRegionsPage,
});
